import React, { useState } from 'react';
import EmailSender from './EmailSender';
import BulkEmailSender from './BulkEmailSender';
import ServerTest from './ServerTest';

const EmailTest = () => {
  const [activeTab, setActiveTab] = useState('single');

  return (
    <div className="container my-4">
      <h3 className="mb-4">Email Communication</h3>

      <ul className="nav nav-tabs mb-4">
        <li className="nav-item">
          <button 
            className={`nav-link ${activeTab === 'single' ? 'active' : ''}`}
            onClick={() => setActiveTab('single')}
          >
            <i className="bi bi-envelope me-2"></i>
            Single Email
          </button>
        </li>
        <li className="nav-item">
          <button 
            className={`nav-link ${activeTab === 'bulk' ? 'active' : ''}`}
            onClick={() => setActiveTab('bulk')}
          >
            <i className="bi bi-envelope-fill me-2"></i>
            Bulk Emails
          </button>
        </li>
        <li className="nav-item">
          <button 
            className={`nav-link ${activeTab === 'test' ? 'active' : ''}`}
            onClick={() => setActiveTab('test')}
          >
            <i className="bi bi-gear me-2"></i>
            Server Test
          </button>
        </li>
      </ul>

      {activeTab === 'single' ? (
        <EmailSender />
      ) : activeTab === 'bulk' ? (
        <BulkEmailSender />
      ) : (
        <ServerTest />
      )}
    </div>
  );
};

export default EmailTest; 